import { HeaderProjectActions } from "./HeaderProjectActions";
import type { ReactNode } from "react";
import { TerminalToggleButton, RightSidebarToggleButton } from "./ChatHeaderPanelToggles";
import { UnavailableHeaderActions } from "./UnavailableHeaderActions";

export function ChatHeaderActionCluster({
  disabledReason,
  canUseRightSidebar,
  hasActiveRightSidebarPanel,
  hiddenActiveAgentCount,
  hiddenRunningTerminalCount,
  onTogglePreview,
  onToggleTerminal,
  projectActions,
  rightSidebarToggleLabel,
  terminalOpen,
  terminalTooltip,
  showPanelLauncher,
}: {
  readonly disabledReason: string | null;
  readonly canUseRightSidebar: boolean;
  readonly hasActiveRightSidebarPanel: boolean;
  readonly hiddenActiveAgentCount: number;
  readonly hiddenRunningTerminalCount: number;
  readonly onTogglePreview: (() => void) | undefined;
  readonly onToggleTerminal: (() => void) | undefined;
  readonly projectActions: ReactNode;
  readonly rightSidebarToggleLabel: string;
  readonly terminalOpen: boolean;
  readonly terminalTooltip: string;
  readonly showPanelLauncher: boolean | undefined;
}) {
  const showRightPanel = panelLauncherVisible(
    showPanelLauncher,
    disabledReason,
    canUseRightSidebar,
    onTogglePreview,
  );
  const panelClassName = disabledReason ? "hidden items-center sm:flex" : "flex items-center";
  if (!projectActions && !onToggleTerminal && !showPanelLauncher) return null;
  return (
    /* Right-aligned view entry point. Render it only while the right sidebar
           is collapsed; once open, the sidebar owns its active tab and switcher. */
    <div
      className="flex shrink-0 items-center gap-0.5 sm:gap-1"
      data-active-panels={hasActiveRightSidebarPanel ? "true" : "false"}
      data-testid="chatheader-right-cluster"
    >
      {projectActions ? <HeaderProjectActions>{projectActions}</HeaderProjectActions> : null}
      {disabledReason ? <UnavailableHeaderActions reason={disabledReason} /> : null}
      <div className={panelClassName}>
        <TerminalToggleButton
          disabledReason={disabledReason}
          onToggle={onToggleTerminal}
          open={terminalOpen}
          hiddenRunningCount={hiddenRunningTerminalCount}
          tooltip={terminalTooltip}
        />

        <RightSidebarToggleButton
          disabledReason={disabledReason}
          show={showRightPanel}
          onToggle={onTogglePreview}
          hasActivePanel={hasActiveRightSidebarPanel}
          hiddenAgentCount={hiddenActiveAgentCount}
          label={rightSidebarToggleLabel}
        />
      </div>
    </div>
  );
}

function panelLauncherVisible(
  show: boolean | undefined,
  reason: string | null,
  canUse: boolean,
  toggle: (() => void) | undefined,
) {
  return Boolean(show && (reason || (canUse && toggle)));
}
